import { useTranslation } from 'react-i18next';

import { Icon, type IconName } from '~/components/Icon';
import { cn } from '~/lib/cn';

interface PlatformBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  iconName: IconName;
  title: string;
  isSelected: boolean;
  onClick: () => void;
}

export function PlatformBlock({
  iconName,
  title,
  isSelected,
  onClick,
  className,
  ...props
}: PlatformBlockProps) {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns.planWizard.sections.objectives',
  });

  return (
    <div
      onClick={onClick}
      className={cn(
        'relative flex h-[5rem] w-[8rem] cursor-pointer flex-col',
        'items-center justify-center gap-xs rounded-sm',
        'border-px transition-all',
        'bg-emphasis-default border-emphasis-subtle',
        isSelected
          ? 'bg-default-inverse/subtle border-primary-pressed'
          : 'hover:border-primary-pressed',
        className,
      )}
      {...props}
    >
      {/* Absolute Check Icon (Top Right) */}
      {isSelected ? (
        <div className="absolute right-sm top-xs">
          <Icon
            type="check-circle"
            variant="solid"
            size="sm"
            className="text-primary-default"
            aria-label={`${t('iconSelected')} ${title}`}
          />
        </div>
      ) : null}

      {/* Main */}
      <span>
        <Icon
          type={iconName}
          variant="brands"
          size="lg"
          aria-label={`${t('icon')} ${title}`}
        />
      </span>

      {/* Title */}
      <span className="text-center text-body-sm">{title}</span>
    </div>
  );
}

PlatformBlock.displayName = 'PlatformBlock';
